import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { BottomDock } from "./BottomDock";
import { ChatBot } from "../components/ChatBot";
import { IntrusionAlarm } from "../components/IntrusionAlarm";

const MainLayout: React.FC = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const requiredStorageKey = "permissions";

    if (localStorage.getItem(requiredStorageKey)) {
      setIsReady(true);
      return;
    }

    const interval = setInterval(() => {
      if (localStorage.getItem(requiredStorageKey)) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 50); // Check every 50ms 

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setIsReady(true);
    }, 2000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center h-screen w-screen bg-gray-900">
        <div className="w-6 h-6 border-2 border-orange-500/20 border-t-orange-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen overflow-hidden bg-white relative flex flex-col">
      {/* Main content area */}
      <main className="flex-1 overflow-y-auto relative bg-white">
        <div className="min-h-full w-full">
          <Outlet />
        </div>
      </main>

      {/* Floating Bottom Dock */}
      <BottomDock />

      {/* Floating Powered By Text */}
      {/* <div className="absolute bottom-1.5 right-4 flex flex-col items-end text-[6.5px] font-black text-black uppercase tracking-widest whitespace-nowrap select-none z-50 pointer-events-none">
        <div className="flex items-center gap-1">
          <span>Powered by</span>
          <span className="text-black">Runners Software Technology</span>
        </div>
        <span className="text-[5px] text-black font-bold mt-0.5">© {new Date().getFullYear()} All Rights Reserved</span>
      </div> */}

      {/* Intrusion Alarm Notification Overlay */}
      <IntrusionAlarm />

      {/* ChatBot Overlay */}
      <ChatBot />
    </div>
  );
};

export default MainLayout;

